__webpack_require__.hmrF = () => ("Investments." + __webpack_require__.h() + ".hot-update.json");